export default __webpack_public_path__ + "static/media/seller-img1.76159197.png";